/** U+2060 WORD JOINER: invisible, and forbids a line break where it sits. */
const WORD_JOINER = '⁠';

/**
 * Thai has no spaces between words, so browsers wrap it with a dictionary that splits some compounds and
 * loanwords (เดิน|ทาง, พาส|ปอร์ต, เช็|กอิน). Each entry is a compound with a space where the dictionary
 * would break it.
 */
const THAI_COMPOUNDS = [
  'เดิน ทาง',
  'พาส ปอร์ต',
  'เช็ กอิน',
  'เส้น ทาง',
  'ความ หมาย',
  'ความ ทรง จำ',
  'ผจญ ภัย',
  'ร่วม ทาง',
  'หนึ่ง เดียว',
  'ประทับ ตรา',
  'ตั้ง ค่า',
  'เต็ม ที่',
  'ที่ อยู่',
  'ส่วน ตัว',
  'แบ่ง ปัน',
  'ช่วง เวลา',
  'ไอซ์ แลนด์',
  'โรด ทริป'
];

/**
 * Puts a word joiner at each dictionary split of the compounds above, so headings and buttons never wrap
 * mid-word. CSS has no equivalent for Thai (keep-all and auto-phrase don't apply to it).
 */
// ponytail: plain substring match, so 'ที่อยู่' would also join inside 'วันที่อยู่…'; harmless there (no line
// break lost that a reader wants), switch to Intl.Segmenter word boundaries if a join ever reads wrong
export const joinThaiCompounds = (text: string): string =>
  THAI_COMPOUNDS.reduce(
    (out, compound) => out.replaceAll(compound.replaceAll(' ', ''), compound.replaceAll(' ', WORD_JOINER)),
    text
  );

/** Copy leaving for meta tags or JSON-LD carries plain text, without the joiners added for line breaking. */
export const stripWordJoiners = (text: string): string => text.replaceAll(WORD_JOINER, '');
